export type ApiErrorOptions = {
  code?: string;
  status?: number;
  detail?: string;
  /** 用户端可对文案做脱敏/裁剪 */
  sanitizeMessage?: (raw: string) => string;
};

/** 业务或 HTTP 层请求失败 */
export class ApiError extends Error {
  override readonly name = "ApiError";

  constructor(message: string, options?: ApiErrorOptions) {
    const raw = message.trim();
    const sanitized = options?.sanitizeMessage?.(raw)?.trim();
    super(sanitized || raw || "请求失败，请稍后再试");
    this.code = options?.code;
    this.status = options?.status;
    this.detail = options?.detail;
  }

  readonly code?: string;
  readonly status?: number;
  readonly detail?: string;
}

export function isApiError(value: unknown): value is ApiError {
  return value instanceof ApiError;
}
